export default __webpack_public_path__ + "static/media/studies_img_three.7baebf94.jpg";